var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseError from "./BaseError";
/*
 * @Author: freedeng
 * @Date: 2019-06-18 10:53:57
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-07-25 19:55:46
 */
var DBErrorType;
(function (DBErrorType) {
    DBErrorType["NOT_SUPPORT_INDEXEDDB"] = "notSupportIndexedDB";
    DBErrorType["OPEN_FAIL"] = "openFail";
    DBErrorType["TRANSACTION_FAIL"] = "transactionFail";
    DBErrorType["DB_BLOCKED"] = "DBBlocked";
    DBErrorType["CHECK_FAIL"] = "checkFail";
    DBErrorType["REQUEST_ERROR"] = "requestError";
})(DBErrorType || (DBErrorType = {}));
var DBError = /** @class */ (function (_super) {
    __extends(DBError, _super);
    function DBError(errorType, message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'DBError';
        _this.errorType = errorType;
        return _this;
    }
    return DBError;
}(BaseError));
export { DBError, DBErrorType };
//# sourceMappingURL=DBError.js.map